import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SERVICEMASTER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ServiceMaster.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ServiceMaster.Code')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const SERVICEMASTER_CONFIG = {
  entityName: 'ServiceMaster',
  localizationKey: 'Controlling::Entity.ServiceMaster',
  fields: SERVICEMASTER_FIELDS,
  permission: 'ControllingSap.ServiceMasters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
